import prototypes from './prototypes'
import directives from './directive'

const install = (Vue: any) => {
  Object.keys(prototypes).forEach((key: string) => {
    Vue.prototype[key] = (prototypes as any)[key]
  })

  Object.keys(directives).forEach((key: string) => {
    Vue.directive(key, directives[key])
  })
}

export default { install }
